import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setIsExamLaunched, setSubject, updateSubjectContentLoadingOnLesson } from '../../store/actions';
import { subjectDuration, getSubjectStatus, calculateDuration, formatDateRange, formatDateRangeShort } from "../../utils/commonFunction.js";
import { Link, useHistory } from "react-router-dom";
import { shortenText } from '../../utils/commonFunction.js';
import { courseStyles } from "./utils/CourseStyles.js";
import { ADMIN_PASSWORD } from "../../utils/Constants";
import Swal from 'sweetalert2';
import Str from '../common/Str';
import moment from 'moment';
import { useParams } from 'react-router-dom/cjs/react-router-dom.js';
import { buildStatusChip } from "./utils/CourseHelperUtils.js";
import { SubjectCardLink, SubjectCardSpan, SubjectSideCard } from "./StyledSubjectSidebar.js";
const SubjectListBox = (props) => {

    const { active, isAdmin, changeSub } = props;
    let { rows } = props;
    const dispatch = useDispatch();
    const [subjectId, setSubjectId] = useState(0)
    const history = useHistory();
    const {isWithHeld} = useSelector((state) => state);

    const { examLaunched } = useSelector(state => state.examLaunched);
    const { qid, sid } = useParams()
    useEffect(() => {
        dispatch(updateSubjectContentLoadingOnLesson("loading"));
    }, [])
    const renderStatusChip = (subject) => {
        const chip = buildStatusChip((subject.show_results === 1 && subject.subjectStatus !== "Not Yet Published")
            ? "Finished" 
            : subject?.subjectStatus, 
            isWithHeld == true 
            ? "witheld" 
            : subject?.studentResult?.pass_status || 0, 
            isWithHeld == true
                ? "WITHHELD"
                : subject?.studentResult?.gradeText,
            subject?.show_results);
        return (
            <div className="flex justify-start items-center h-full pl-[17px] mt-1">
                <div className="sub-info-lst-rgt">
                    <span style={{ ...courseStyles.chipBase, ...chip.style, color: chip.fontColor || "var(--white)" }}>
                        {chip?.icon ? <i style={{ color: chip.iconColor}}className={chip.icon}></i> : null} {chip.label}
                    </span>
                </div>
            </div>
        );
    }

    const handleSelectSubject = (sid) => {
        props.parentGetSubContentMethod(sid);
        if (subjectId !== sid) {
            dispatch(setSubject({ sid }));
            setSubjectId(sid);
        }
    }
    useEffect(() => {
        if (rows && rows.length > 0) {
            rows = rows.sort((a, b) => {
                if (b?.subjectStatus === "Not Yet Published" && a?.subjectStatus !== "Not Yet Published") {
                    return -1;
                } else if (b?.subjectStatus !== "Not Yet Published" && a?.subjectStatus === "Not Yet Published") {
                    return 1;
                }
                return 0;
            });
        }
    }, [rows])

    return (
        <>
            <>
                {rows && rows.length > 0 && rows?.map((row) => {
                    return (
                        <SubjectSideCard
                            key={row.intake_id}
                            active={active == (isAdmin == 1 ? row.id : row.intake_id)}
                            disabled={row.subjectStatus === "Not Yet Published" && isAdmin != 1}
                            onClick={() => {
                                if (row.subjectStatus !== "Not Yet Published" || isAdmin == 1) {
                                    if (
                                        history.location.pathname === examLaunched?.url &&
                                        examLaunched?.isExamLaunched
                                    ) {
                                        dispatch(setIsExamLaunched({ ...examLaunched, isClicked: true }));
                                    } else {
                                        dispatch(updateSubjectContentLoadingOnLesson("loading"));
                                        handleSelectSubject(isAdmin === 1 ? row.id : row.intake_id);
                                    }
                                }
                            }}
                        >
                            {
                                isAdmin === 1 ?
                                    (
                                        <SubjectCardLink
                                            to={`/courseinfo/${qid}/subject/${row.id}/${ADMIN_PASSWORD}`}>
                                        </SubjectCardLink>
                                    ) : (
                                        history.location.pathname === examLaunched?.url && examLaunched?.isExamLaunched
                                            ? <SubjectCardSpan
                                                onClick={() => dispatch(setIsExamLaunched({ ...examLaunched, isClicked: true }))}
                                            ></SubjectCardSpan>
                                            : <SubjectCardLink
                                                to={(row.subjectStatus != "Not Yet Published" && isAdmin !== 1) ? `/course/${qid}/subject/${row.intake_id}` : "#"}>
                                            </SubjectCardLink>
                                    )
                            }
                            <div className='sub_box_name'>
                                <h3 className="mb-1" title={row.name}>{shortenText(row.name, 32)}</h3>
                            </div>
                            <ul className="subject-info-list list-unstyled d-flex mb-1">
                                <li>
                                    <div className="sub-info-lst-row d-flex items-baseline">
                                        <div className="sub-info-lst-lft">
                                            <span className="sub-icon">
                                                <i className="fal fa-calendar-clock" style={{ fontSize: "10px" }}></i>
                                            </span>
                                        </div>
                                        <div className="sub-info-lst-rgt" style={{padding: "0px 10px 8px 0px"}}>
                                            {row.subject_type === "mentored" && isAdmin !== 1 ? (
                                                (() => {
                                                    switch (row.student_intake_status) {
                                                        case 0:
                                                            return (
                                                                <>
                                                                    <small>Recommended Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        case 1:
                                                        case 4:
                                                            return (
                                                                <>
                                                                    <small>Committed Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        case 2:
                                                        case 3:
                                                            return (
                                                                <>
                                                                    <small>Completion Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                        default:
                                                            return (
                                                                <>
                                                                    <small>Recommended Date</small>
                                                                    <p>{row.start && row.end ? formatDateRange(row.start, row.end) : "Invalid Date"}</p>
                                                                </>
                                                            );
                                                    }
                                                })()
                                            ) : (
                                                <>
                                                    {row.hide_dates && (row.subjectStatus === "Not Yet Published" && isAdmin !== 1) ? (
                                                        <p>-</p>
                                                    ) : (
                                                        <>
                                                            <p>{row.start && row.end ? formatDateRangeShort(row.start, row.end) : "Invalid Date"}</p>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </li>
                                {row.subject_type === "mentored" ?
                                (
                                <li className="status-detail-li">
                                    <div className="sub-info-lst-row" style={{ display: "flex", justifyContent: "start", alignItems: "center", height: "100%", paddingLeft: "17px", }}>
                                        {renderStatusChip(row)}
                                    </div>
                                </li>
                                ) : ""}
                            </ul>
                            {row.subject_type !== "mentored" ? renderStatusChip(row) : "-"}
                        </SubjectSideCard>
                    )
                })}
            </>
        </>
    )
}

export default SubjectListBox